// HUD：ハートUI（半ハート単位、ハート形状で描画）
import Phaser from 'phaser';
import { bus } from '../systems/EventBus';

const HEART_SIZE = 18;
const HEART_GAP = 4;
const HEART_MARGIN_X = 16;
const HEART_MARGIN_Y = 14;

export class UIScene extends Phaser.Scene {
  private heartsGfx!: Phaser.GameObjects.Graphics;

  constructor() {
    super('UIScene');
  }

  create(): void {
    this.heartsGfx = this.add.graphics();
    bus.on('player-hp', ({ hp, maxHp }) => this.drawHearts(hp, maxHp));
    this.drawHearts(10, 10);
  }

  // hp/maxHp は半ハート単位（2pt=1ハート）
  private drawHearts(hp: number, maxHp: number): void {
    this.heartsGfx.clear();
    const totalHearts = Math.ceil(maxHp / 2);
    for (let i = 0; i < totalHearts; i++) {
      const x = HEART_MARGIN_X + i * (HEART_SIZE + HEART_GAP);
      const y = HEART_MARGIN_Y;
      const remain = hp - i * 2;
      let state: 'full' | 'half' | 'empty';
      if (remain >= 2) state = 'full';
      else if (remain === 1) state = 'half';
      else state = 'empty';
      this.drawHeart(x, y, state);
    }
  }

  // ピクセルアート風のハート形状を描画する
  // 5x5のグリッドを HEART_SIZE/5 倍にスケールして描く
  private drawHeart(x: number, y: number, state: 'full' | 'half' | 'empty'): void {
    const g = this.heartsGfx;
    const cell = HEART_SIZE / 5; // 1セル=約3.6px
    // ハート形：5x5 の塗りパターン（1=赤、0=透明、L=ハイライト）
    // . X . X .
    // X X X X X
    // X X X X X
    // . X X X .
    // . . X . .
    const pattern = [
      [0, 1, 0, 1, 0],
      [1, 1, 1, 1, 1],
      [1, 1, 1, 1, 1],
      [0, 1, 1, 1, 0],
      [0, 0, 1, 0, 0],
    ];
    // 黒い縁取り（ハート形より1px外側）
    g.fillStyle(0x000000, 1);
    for (let py = 0; py < 5; py++) {
      for (let px = 0; px < 5; px++) {
        if (pattern[py]![px] === 1) {
          g.fillRect(x + px * cell - 1, y + py * cell - 1, cell + 2, cell + 2);
        }
      }
    }
    // 本体（フル＝赤、ハーフ＝左半分のみ赤）
    if (state !== 'empty') {
      const fullColor = 0xff3344;
      const emptyColor = 0x441111;
      for (let py = 0; py < 5; py++) {
        for (let px = 0; px < 5; px++) {
          if (pattern[py]![px] !== 1) continue;
          // ハーフは右半分(px>=3)を空色に
          const filled = state === 'full' || px < 2 || (px === 2 && py < 3);
          g.fillStyle(filled ? fullColor : emptyColor, 1);
          g.fillRect(x + px * cell, y + py * cell, cell, cell);
        }
      }
      // ハイライト（左上2セル）
      if (state === 'full') {
        g.fillStyle(0xffaabb, 1);
        g.fillRect(x + 1 * cell, y + 1 * cell, cell, cell);
      }
    } else {
      // empty：暗赤で塗る
      g.fillStyle(0x441111, 1);
      for (let py = 0; py < 5; py++) {
        for (let px = 0; px < 5; px++) {
          if (pattern[py]![px] === 1) {
            g.fillRect(x + px * cell, y + py * cell, cell, cell);
          }
        }
      }
    }
  }
}
